import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography
} from '@mui/material';
import {
  Home as HomeIcon,
  Menu as MenuIcon,
  Login as LoginIcon,
  PersonAdd as RegisterIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import landingTheme from '../theme/landingTheme';

const LandingNavbar = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    // Se non siamo nella landing page, naviga prima lì
    if (window.location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    setMobileMenuOpen(false);
  };

  return (
    <>
      <AppBar 
        position="sticky" 
        elevation={4} 
        sx={{ 
          bgcolor: 'rgba(255,255,255,0.98)', 
          backdropFilter: 'blur(10px)',
          zIndex: 1100
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer' }} onClick={() => navigate('/')}>
            <HomeIcon sx={{ fontSize: 32, color: landingTheme.colors.primary }} />
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 700, 
                color: landingTheme.colors.primary, 
                display: { xs: 'none', sm: 'block' } 
              }}
            >
              Gestionale Anziani
            </Typography>
          </Box>
          
          {/* Desktop Menu */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
            <Button onClick={() => navigate('/features')} sx={{ color: '#333', fontWeight: 600 }}>
              Funzionalità
            </Button>
            <Button onClick={() => navigate('/pricing')} sx={{ color: '#333', fontWeight: 600 }}>
              Prezzi
            </Button>
            <Button onClick={() => navigate('/about')} sx={{ color: '#333', fontWeight: 600 }}>
              Chi Siamo
            </Button>
            <Button onClick={() => scrollToSection('contact')} sx={{ color: '#333', fontWeight: 600 }}>
              Contatti
            </Button>
            <Button 
              onClick={() => navigate('/login')} 
              startIcon={<LoginIcon />} 
              sx={{ color: '#333', fontWeight: 600 }}
            >
              Accedi
            </Button>
            <Button 
              onClick={() => navigate('/register')} 
              variant="contained" 
              startIcon={<RegisterIcon />} 
              sx={{ fontWeight: 600 }}
            >
              Registrati
            </Button>
          </Box>

          {/* Mobile Menu Icon */}
          <IconButton 
            sx={{ display: { xs: 'block', md: 'none' }, color: landingTheme.colors.primary }} 
            onClick={() => setMobileMenuOpen(true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)}>
        <Box sx={{ width: 250, pt: 2 }}>
          <List>
            <ListItem button onClick={() => { navigate('/features'); setMobileMenuOpen(false); }}>
              <ListItemText primary="Funzionalità" />
            </ListItem>
            <ListItem button onClick={() => { navigate('/pricing'); setMobileMenuOpen(false); }}>
              <ListItemText primary="Prezzi" />
            </ListItem>
            <ListItem button onClick={() => { navigate('/about'); setMobileMenuOpen(false); }}>
              <ListItemText primary="Chi Siamo" />
            </ListItem>
            <ListItem button onClick={() => scrollToSection('contact')}>
              <ListItemText primary="Contatti" />
            </ListItem>
            <Divider sx={{ my: 1 }} />
            <ListItem button onClick={() => { navigate('/login'); setMobileMenuOpen(false); }}>
              <ListItemText primary="Accedi" />
            </ListItem>
            <ListItem button onClick={() => { navigate('/register'); setMobileMenuOpen(false); }}>
              <ListItemText primary="Registrati" />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default LandingNavbar;
